<app-chip [color]="getColor(status)">
  {{ status | titlecase }}
</app-chip>
